import { request } from './request';
import { root, id } from './verify';

export const verify = {
  ...root,
  id,
  request,
};
